import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import classnames from 'classnames';
import { WidgetTypes } from './types';
import styles from './index.module.scss';

function Widget({
  title,
  description,
  content,
  actions,
  classNames = '',
}: WidgetTypes) {
  return (
    <div className={classnames(styles.widgetWrapper, classNames)}>
      <div className={styles.widgetWrapper__header}>
        <div className={styles.widgetWrapper__header__text}>
          {Boolean(title) && <Text type="h5">{title}</Text>}
          {Boolean(description) && (
            <Text
              type="sublabel"
              classNames={styles.widgetWrapper__header__desc}
            >
              {description}
            </Text>
          )}
        </div>
        {actions}
      </div>
      <div> {content}</div>
    </div>
  );
}

export default Widget;
